import type { ComponentPropsWithRef } from 'react';

import { Accordion } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { rootStyle } from './Timeline.css';

type Props = ComponentPropsWithRef<'ol'>;

export const TimelineRoot = ({ children, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <Accordion.Root
      multiple
      render={
        <ol
          {...delegated}
          aria-label={delegated['aria-label'] ?? t('common:timeline.ariaLabel')}
          className={clsx(rootStyle, delegated.className)}
        />
      }
    >
      {children}
    </Accordion.Root>
  );
};
